import React from 'react'

import { RibbonTriggerContainer } from 'RibbonTrigger'
import type * as braintree from 'braintree-web'

import { DeliveryDetailsForm } from 'routes/Checkout/Components/DeliveryDetailsForm'
import type { CheckoutStepIds } from 'routes/Checkout/checkoutConfig'

type DeliveryProps = {
  onStepChange: (stepId: CheckoutStepIds) => void
  braintreeClientInstance: braintree.Client | null
  googlePayInstance: braintree.GooglePayment | null
  threeDSecureInstance: braintree.ThreeDSecure | null
  braintreePayPalCheckoutComponent: braintree.PayPalCheckout | null
  isPayPalInitialized: boolean
  setIsPayPalInitialized: (value: boolean) => void
  submitOrder: () => void
}

export const Delivery = ({
  onStepChange,
  braintreeClientInstance,
  googlePayInstance,
  threeDSecureInstance,
  submitOrder,
  isPayPalInitialized,
  setIsPayPalInitialized,
  braintreePayPalCheckoutComponent,
}: DeliveryProps) => (
  <>
    <DeliveryDetailsForm
      onStepChange={onStepChange}
      braintreeClientInstance={braintreeClientInstance}
      googlePayInstance={googlePayInstance}
      threeDSecureInstance={threeDSecureInstance}
      submit={submitOrder}
      isPayPalInitialized={isPayPalInitialized}
      setIsPayPalInitialized={setIsPayPalInitialized}
      braintreePayPalCheckoutComponent={braintreePayPalCheckoutComponent}
    />
    <RibbonTriggerContainer name="checkout-delivery" />
  </>
)
